import React from "react";
import userImage from "../assets/user-assets/user-image.png";
import { Link } from "react-router-dom";
import zigzags from "../assets/user-assets/zigzags.png";
import plus from "../assets/user-assets/plus.png";
import cube from "../assets/user-assets/cube.png";
import circle from "../assets/user-assets/circle.png";
import dots from "../assets/user-assets/dots.png";
import { ReactTyped } from "react-typed";

const Home = () => {
  return (
    <div className="mx-3 sm:mx-12">
      <div className="max-w-[1200px] mx-auto flex flex-col xl:flex-row justify-between items-center my-8 gap-8 xl:gap-0">
        <div className="flex flex-col items-center xl:items-start justify-center gap-8 home-container">
          <h1 className="text-3xl font-medium text-[#343d68] introduction-heading">
            Hello, I am Rahul Bhutaiya...
          </h1>

          <h2 className="text-5xl leading-10 font-medium text-[#343d68] text-center running-text">
            I am a{" "}
            <span>
              <ReactTyped
                className="text-[#4e45d5]"
                strings={[
                  "Software Engineer",
                  "Frontend Developer",
                  "Backend Developer",
                ]}
                loop
                backSpeed={30}
                typeSpeed={70}
              />
            </span>
          </h2>

          <p className="w-[70%] font-medium text-center xl:text-left introduction-description">
            I'm a Software Engineer showcasing my journey through this portfolio
            website.
          </p>

          <Link
            to="/contact"
            className="hidden xl:block self-start bg-[#e84949] text-white text-lg font-normal rounded-md py-3 px-10 button-shadow"
          >
            Let's Connect
          </Link>
        </div>

        <div className="relative xl:mr-8">
          <img
            src={userImage}
            alt="rahul"
            className="h-[390px] w-[355px] rounded-md object-cover box-content animate-user-img "
          />
          <img
            className="absolute top-6 -left-[0.3rem] animate-zigzag animating-user-image-icons-1"
            src={zigzags}
            alt="zigzags"
          />
          <img
            className="absolute -top-[0.8rem] left-1/2 animate-plus animating-user-image-icons-2"
            src={plus}
            alt="plus"
          />
          <img
            className="absolute -top-[0.8em] -right-8 animate-cube animating-user-image-icons-3"
            src={cube}
            alt="cube"
          />
          <img
            className="absolute bottom-0 left-0 animate-bounce animating-user-image-icons-4"
            src={circle}
            alt="circle"
          />
          <img
            className="absolute -bottom-4 -right-8 animate-dots animating-user-image-icons-5"
            src={dots}
            alt="dots"
          />
        </div>

        <Link
          to="/contact"
          className="xl:hidden block  bg-[#e84949] text-white text-lg font-normal rounded-md py-3 px-10 button-shadow"
        >
          Let's Connect
        </Link>
      </div>
    </div>
  );
};

export default Home;
